import { useEffect, useState } from 'react';
import { apiFetchResponse } from '../lib/apiFetch';

/**
 * The backend's Proof of Payment check (GET proof-of-payment/:id/check): when a
 * Quebec case's payments are more than its contracts now total, the warning to
 * show staff — likely death-certificate lines erased from the contract, so the
 * Proof of Payment amount may include certificates. Null when there's nothing
 * to warn about, the case isn't Quebec, or the check fails (it never blocks).
 */
export function useProofOfPaymentWarning(funeralId: number | string | undefined, enabled = true): string | null {
  const [message, setMessage] = useState<string | null>(null);

  useEffect(() => {
    setMessage(null);
    if (!funeralId || !enabled) return;
    let cancelled = false;
    void (async () => {
      try {
        const res = await apiFetchResponse(`proof-of-payment/${funeralId}/check`);
        if (!res.ok) return;
        const data = await res.json();
        if (!cancelled && data?.applies && data?.overpaid && typeof data.message === 'string') {
          setMessage(data.message);
        }
      } catch {
        // Advisory only: a failed check shows nothing.
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [funeralId, enabled]);

  return message;
}
